import React from 'react';

import { Box, Typography } from '@mui/material';

import { LereToursPricingSuggestion } from '../types';

import { formatDate } from './toursPricingUtils';

export default function ToursScheduleFormatter({ row }: { row: LereToursPricingSuggestion }) {
  return (
    <Box sx={{ alignSelf: 'flex-start', py: 1 }}>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Handback:
        </Typography>{' '}
        {formatDate(row.handback_date)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Leadtime:
        </Typography>{' '}
        {row.leadtime?.toLocaleString() ?? '—'}
      </Typography>
    </Box>
  );
}
